import { LoginDevice } from './login-devices.model';

export type GenerateLoginDevicesOptions = Partial<LoginDevice>;

export function generateLoginDevicesObject({
  userAgent = 'Mozilla/5.0',
  platform = 'Web',
  city = 'Manila',
  country = 'Philippines',
  lastLogin = Date.now(),
  id = lastLogin,
}: GenerateLoginDevicesOptions = {}): LoginDevice {
  return {
    id,
    userAgent,
    platform,
    city,
    country,
    lastLogin,
  };
}
